import React from "react";
import { DetailSidePanel } from "../DetailSidePanel";
import { FlightFromAiSidePanelDetails } from "./FlightFromAiSidePanelDetails";

export interface FlightFromAiSidePanelProps {
  extractedFlightId: number
  artist: server.dto.ArtistSmall
  trigger: JSX.Element
}

export const FlightFromAiSidePanel = (props: FlightFromAiSidePanelProps) => {
  return <DetailSidePanel
    apiCall={() => window.CoreApi.Extractor.GetExtractedFlight(props.extractedFlightId)}
    apiKey="parseFlightSuccess"
    entityId={props.extractedFlightId}
    title="Flight from AI"
    footerContent={<>
    </>}
    trigger={props.trigger}
  >
    {(data) => <FlightFromAiSidePanelDetails
      data={data}
      artist={props.artist}
    />}
  </DetailSidePanel>
};